
export class XmlConfiguration {
encoding: string;
namespace: string;
rootField: string;
version: string;
}

